import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
export function getInitialSelection(selectAllByDefault, optionsLength) {
    return {
        selectAll: selectAllByDefault,
        optionsLength,
        selectAllByDefault,
        selectedOptionsIndexes: new Set(),
        labelToDisplay: null,
        previousState: {
            selectAll: selectAllByDefault,
            optionsLength,
            selectAllByDefault,
            selectedOptionsIndexes: new Set(),
            labelToDisplay: null
        }
    };
}
function shouldMarkSelectAll(selectOptionsIndexes, selectAllByDefault, optionsLength) {
    return selectAllByDefault ? selectOptionsIndexes.size === 0 : selectOptionsIndexes.size === optionsLength;
}
function reducer(state, action) {
    switch(action.type){
        case 'selectAll':
            {
                return _object_spread_props(_object_spread({}, state), {
                    selectAll: state.selectAllByDefault ? true : !state.selectAll,
                    selectedOptionsIndexes: state.selectAllByDefault || state.selectedOptionsIndexes.size > 0 ? new Set() : new Set(Array.from({
                        length: state.optionsLength
                    }, (_, i)=>i))
                });
            }
        case 'selectOption':
            {
                const isInMap = state.selectedOptionsIndexes.has(action.value);
                const newSelectedOptionsIndexes = new Set(state.selectedOptionsIndexes);
                if (isInMap) {
                    newSelectedOptionsIndexes.delete(action.value);
                } else {
                    newSelectedOptionsIndexes.add(action.value);
                }
                return _object_spread_props(_object_spread({}, state), {
                    selectAll: shouldMarkSelectAll(newSelectedOptionsIndexes, state.selectAllByDefault, state.optionsLength),
                    selectedOptionsIndexes: newSelectedOptionsIndexes
                });
            }
        case 'selectOptions':
            {
                const selectedOptionsIndexes = new Set(action.value);
                return _object_spread_props(_object_spread({}, state), {
                    selectAll: state.selectAllByDefault ? selectedOptionsIndexes.size === 0 : selectedOptionsIndexes.size === state.optionsLength,
                    selectedOptionsIndexes
                });
            }
        case 'setOptionsLength':
            {
                if (state.optionsLength === action.value) return state;
                return _object_spread_props(_object_spread({}, state), {
                    optionsLength: action.value,
                    selectAll: shouldMarkSelectAll(state.selectedOptionsIndexes, state.selectAllByDefault, action.value),
                    previousState: _object_spread_props(_object_spread({}, state.previousState), {
                        optionsLength: action.value,
                        selectAll: shouldMarkSelectAll(state.previousState.selectedOptionsIndexes, state.selectAllByDefault, action.value)
                    })
                });
            }
        case 'applyChanges':
            {
                const { previousState: _ } = state, currentState = _object_without_properties(state, [
                    "previousState"
                ]);
                const newState = _object_spread_props(_object_spread({}, currentState), {
                    labelToDisplay: action.label || null
                });
                return _object_spread_props(_object_spread({}, newState), {
                    previousState: _object_spread({}, newState)
                });
            }
        case 'revert':
            {
                const { previousState } = state;
                return _object_spread_props(_object_spread({}, previousState), {
                    previousState
                });
            }
        default:
            throw new Error('unknown filters action');
    }
}
export function createReducer() {
    return reducer;
}
